import React from 'react'
import { Link } from "react-router-dom";


const Urology = () => {
    return (
        <>
            <div className="dz-bnr-inr dz-banner-dark overlay-secondary-middle dz-bnr-inr-md" style={{ background: "url(./assets/img/Hospital.jpg)" }}>
                <div className="container">
                    <div className="dz-bnr-inr-entry d-table-cell">
                        <h1 className="" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp', color: "white" }}>यूरोलॉजी</h1>
                        <nav aria-label="breadcrumb" className="breadcrumb-row wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                            <ul className="">
                                <li className="breadcrumb-item"><Link to="/">होम</Link></li>
                                <li className="breadcrumb-item">यूरोलॉजी</li>
                            </ul>
                        </nav>
                        <div className="dz-btn">
                            <a to="tel:+91 9165155945" className="btn btn-lg btn-icon btn-primary radius-xl btn-shadow mb-3 mb-sm-0">
                                <span className="left-icon">
                                    <i className="feather icon-phone-call" />
                                </span>
                                +91 9165155945
                            </a>
                        </div>
                    </div>
                </div>
                <span className="text-vertical">24/7 आपातकालीन सेवा</span>
                <ul className="dz-social">
                    <li>
                        <Link to="https://www.facebook.com/p/Omkar-Multispeciality-Hospital-61578676481836/" target="_blank">
                            <i className="fa-brands fa-facebook-f" />
                        </Link>
                    </li>
                    <li>
                        <a to="https://www.instagram.com" target="_blank">
                            <i className="fa-brands fa-instagram" />
                        </a>
                    </li>

                    <li>
                        <a to="https://twitter.com" target="_blank">
                            <i className="fa-brands fa-x-twitter" />
                        </a>
                    </li>
                    <li>
                        <a to="https://www.youtube.com" target="_blank">
                            <i className="fa-brands fa-youtube" />
                        </a>
                    </li>
                </ul>
            </div>

            <section className="content-inner service-single">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 single-inner order-lg-1">
                            <div className="single-media dz-media single-media height-sm radius-lg wow fadeInUp" data-wow-delay="0.1s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.1s', animationName: 'fadeInUp' }}>
                                <img src="./assets/img/Urology_1.webp" alt className="object-fit-cover" />
                            </div>
                            <div className="content-item wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                                <h2>यूरोलॉजी</h2>
                                <p>
                                    हमारा यूरोलॉजी डिपार्टमेंट यूरिनरी ट्रैक्ट और मेल रिप्रोडक्टिव सिस्टम से जुड़ी बीमारियों का पूरा डायग्नोसिस और एडवांस्ड इलाज करता है। हम मॉडर्न टेक्नोलॉजी और सबूतों पर आधारित मेडिकल तरीकों का इस्तेमाल करके हाई-क्वालिटी, मरीज़ों पर ध्यान देने वाली देखभाल देने के लिए तैयार हैं।

                                    यूरोलॉजिस्ट की हमारी एक्सपर्ट टीम किडनी, यूरेटर, ब्लैडर, यूरेथ्रा और प्रोस्टेट को प्रभावित करने वाली बीमारियों का इलाज करने में माहिर है। हम पुरुषों, महिलाओं और बच्चों में यूरोलॉजिकल समस्याओं की एक बड़ी रेंज के लिए मेडिकल और सर्जिकल मैनेजमेंट दोनों देते हैं।
                                </p>
                            </div>
                            <div className="content-item wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.3s', animationName: 'fadeInUp' }}>
                                <h3>हम इन स्थितियों का इलाज करते हैं</h3>
                                <ul className="text-secondary grid-2 m-b30">
                                    <li>  ✅   किडनी स्टोन का इलाज (मेडिकल मैनेजमेंट, लेजर और एंडोस्कोपिक प्रोसीजर) </li>
                                    <li>  ✅   प्रोस्टेट केयर, जिसमें बढ़े हुए प्रोस्टेट (BPH) का इलाज शामिल है </li>
                                    <li>  ✅   यूरिनरी ट्रैक्ट इन्फेक्शन (UTI) का मैनेजमेंट </li>
                                    <li>  ✅   ब्लैडर डिसऑर्डर और यूरिनरी इनकॉन्टिनेंस का इलाज </li>
                                    <li>  ✅    पुरुषों में इनफर्टिलिटी का मूल्यांकन और इलाज</li>
                                    <li>  ✅   इरेक्टाइल डिसफंक्शन का इलाज </li>
                                    <li>  ✅    यूरोलॉजिकल कैंसर स्क्रीनिंग और मैनेजमेंट (किडनी, ब्लैडर, प्रोस्टेट)</li>
                                    <li>  ✅   बच्चों की यूरोलॉजी सर्विस </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-4 m-b30">
                            <aside className="side-bar sticky-top left">
                                <div className="widget service_menu_nav bg-secondary wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                                    <div className="widget-title">
                                        <h4 className="title">सभी सेवाएँ</h4>
                                    </div>
                                    <ul>
                                        <li className="active" ><Link to="/urology">यूरोलॉजी</Link></li>
                                        <li ><Link to="/dermatology">त्वचा विशेषज्ञ</Link></li>
                                        <li><Link to="/pulmonology">पल्मोनोलॉजी</Link></li>
                                        <li><Link to="/ent">कान, नाक और गले</Link></li>
                                        <li><Link to="/paediatrics">बाल चिकित्सा</Link></li>
                                        <li><Link to="/gynaecology">प्रसूति एवं स्त्री रोग</Link></li>
                                        <li ><Link to="/dental">डेंटल</Link></li>
                                        <li><Link to="/general-medicine">सामान्य दवा</Link></li>
                                        <li><Link to="/general-surgery">जनरल सर्जरी</Link></li>
                                        <li><Link to="/orthopedic">ऑर्थोपेडिक</Link></li>
                                        <li><Link to="/physiotherapy">फिजियोथेरेपी</Link></li>
                                        <li><Link to="/anaesthesiology">एनेस्थिसियोलॉजी</Link></li>
                                        <li><Link to="/general-medicine">जनरल मेडिसिन</Link></li>
                                    </ul>
                                </div>
                                <div className="widget_contact" style={{ backgroundImage: 'url(./assets/images/background/bg3.png)' }} data-wow-delay="0.4s" data-wow-duration="0.7s">
                                    <div className="widget-content">
                                        <img src="./assets/images/question.png" width={80} alt />
                                        <h4 className="title">क्या आपको किसी मदद की ज़रूरत है?</h4>
                                        <div className="phone-number">
                                            <a href="tel:+919165155945">+91 9165155945</a>
                                        </div>
                                        <div className="email">
                                            <a href="mailto:omkarmultispecialityhospital1@gmail.com">omkarmultispecialityhospital1
                                                @gmail.com</a>
                                        </div>
                                        <div className="link-btn">
                                            <a to="/contact-us" className="btn btn-lg btn-icon btn-white hover-secondary btn-shadow">
                                                Contact Us <span className="right-icon"><i className="feather icon-arrow-right" /></span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </aside>
                        </div>
                    </div>
                </div>
            </section>


        </>
    )
}

export default Urology